<template>
  <v-row>
    <v-col>
      <v-data-table
        id="ticket-list-table"
        :loading="loading"
        :headers="headers"
        :items="ticketList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100],
        }"
        :items-per-page="perPage"
        item-key="id"
        class="elevation-2 my-6 mx-1 ticket-list-table"
      >
        <template v-slot:[`header.customHeader`]="{ header }">
          <!-- Customized header content -->
          <div class="body-1 font-weight-medium text--primary">
            {{ header.text }} ({{ totalItems }})
          </div>
        </template>
        <template v-slot:[`item.customHeader`]="{ item }">
          <ticket :item="item" />
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
import { $tickets } from "@core/services"
import Ticket from './Ticket.vue';
import { mapGetters } from "vuex"

export default {
    name: "contact-dashboard-tickets",
    components: { Ticket },
    props: {
      contactInfo: {
        type: Object,
      }
    },
    data() {
        return {
          ticketList: [],
          headers: [
            { text: "All Tickets", sortable: false, value: "customHeader" }
          ],
          perPage: 10,
          page: 1,
          totalItems: 0,
          pagination: {},
          loading: false,
        };
    },
    computed: {
      ...mapGetters({
        account: 'auth/account.current',
      }),
      contactSortName() {
      let shortName = "";
      if (this.ticketDetails.contact_name) {
        let name = this.ticketDetails.contact_name.split(" ");
        if (name.length >= 2) {
          shortName = name[0].charAt(0) + name[1].charAt(0);
        } else {
          shortName = name[0].charAt(0);
        }
      }
      return shortName;
    },
    },
    mounted() {
     this.fetchTickets()
    },
    watch: {
      pagination: {
        handler(newVal, oldVal) {
          /** prevent this check to invoked function on page load */
          if (oldVal.itemsPerPage) {
            this.fetchTickets();
          }
        },
        deep: true,
      },
    },
    methods: {
      async fetchTickets() {
        this.loading = true;
        const { page, itemsPerPage} = this.pagination;
        const query = {
          q: {
            contact_email_eq: this.contactInfo.email
          }
        }
        const data = {
          page,
          per_page: itemsPerPage,
          q: {...query.q},
        };
        await $tickets.fetch(data, {}).then((response) => {
          this.totalItems = response.data.pagination.total_count
          this.ticketList = response.data.tickets
        }).finally(() => {
          this.loading = false;
        });
      },
      onRedirect (item) {
        if (process.env.VUE_APP_PRODUCT == 'Service') {
          this.$router.push({ name: 'ticket-details', params: { id: item.id } })
        } else {
          window.open(`/service/${this.account.id}/tickets/${item.id}`, '_blank');
        }
      },
      onDescription (item) {
        this.showDescription = true
        this.ticketDetails = item
      }
    },
};
</script>
<style lang="scss" scoped>
</style>
